import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 125" {...this.props}><path d="M80.9 66.9c-4 0-7.5 1.6-10.1 4.3L33 52.2c.1-.7.2-1.5.2-2.2s-.1-1.5-.2-2.2l37.9-18.9c2.6 2.6 6.1 4.3 10.1 4.3 7.8 0 14.1-6.3 14.1-14.1S88.7 5 80.9 5s-14.1 6.3-14.1 14.1c0 .8.1 1.5.2 2.2L29.2 40.2c-2.6-2.6-6.1-4.3-10.1-4.3C11.3 35.9 5 42.2 5 50s6.3 14.1 14.1 14.1c4 0 7.6-1.6 10.1-4.3L67 78.7c-.1.7-.2 1.5-.2 2.2 0 7.8 6.3 14.1 14.1 14.1S95 88.7 95 80.9s-6.3-14-14.1-14z" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/assets/icons/share.svg